import { render, staticRenderFns } from "./Expediente.vue?vue&type=template&id=2e7de764"
import script from "./Expediente.vue?vue&type=script&lang=js"
export * from "./Expediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7de764')) {
      api.createRecord('2e7de764', component.options)
    } else {
      api.reload('2e7de764', component.options)
    }
    module.hot.accept("./Expediente.vue?vue&type=template&id=2e7de764", function () {
      api.rerender('2e7de764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/Expediente.vue"
export default component.exports